export default __webpack_public_path__ + "static/logo_blue_new_25-c0160a04144f2f572ceea5df33a62c7d.png";